import { render, staticRenderFns } from "./centerSCSearch.vue?vue&type=template&id=5246dbec&scoped=true&"
import script from "./centerSCSearch.vue?vue&type=script&lang=js&"
export * from "./centerSCSearch.vue?vue&type=script&lang=js&"
import style0 from "./centerSCSearch.vue?vue&type=style&index=0&id=5246dbec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5246dbec",
  null
  
)

export default component.exports